import { ChangeCustomerDto } from '@app-types/customer';
import axios from './axios';

const updateCustomer = ({ id, customer }: { id: string | undefined; customer: ChangeCustomerDto }) => axios.patch(`/customers/change-customer-info/${id}`, customer);

const deleteCustomer = (id: string | undefined) => axios.delete(`/customers/${id}`);

export default {
  updateCustomer,
  deleteCustomer,
};
